import { composeIO } from 'react-compose-io'
import { itemGrupoRegraIO } from './ItemGrupoRegra.IO'
import ItemGrupoRegraView from './ItemGrupoRegra.View'

export const ItemGrupoRegra = composeIO(ItemGrupoRegraView, itemGrupoRegraIO)
